import { createHandler, createReducer, DefaultAction } from "core/actions";

export const initState = {
    open: false,
    url: null,
};
export class ON_OPEN_PDF extends DefaultAction {
    callRdx(state, { payload }) {
        return Object.assign({}, state, {
            url: payload.url,
            open: true,
        });
    }
}

export class ON_CLOSE_PDF extends DefaultAction {
    callRdx(state) {
        return Object.assign({}, state, {
            open: false,
        });
    }
}

export class CLEAN extends DefaultAction {
    callRdx() {
        return initState;
    }
}
export const actions = {
    ON_OPEN_PDF: new ON_OPEN_PDF(),
    ON_CLOSE_PDF: new ON_CLOSE_PDF(),
    CLEAN: new CLEAN(),
};

const handlers = createHandler(actions);

export default createReducer(initState, handlers);
